
































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Infor from '../../../api/v2/models/information'
import api from '../../../api/v2/api'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import Information from '../../../api/v2/models/information'
import InformationView from '../atoms_molecules/InformationView.vue'
import { ROUTER_NAME } from '../../router'
import { userState } from '../../stores/user'

@Component({
  components: {
    InformationView,
  }
})
export default class InforList extends Vue {
  get user() {
    return userState.user
  }

  infors: Infor[] = []
  page = 0
  isEnd = false
  loading = false
  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: 'お知らせ一覧',
      disabled: false,
      exact: true,
      to: '/classroom/infors'
    }
  ]
  async created() {
    headerState.setTitle('お知らせ一覧')
    footerState.setFooterDefault()
    window.addEventListener('scroll', this.handleScroll)
    this.loadInfors()
  }

  handleScroll(e) {
    if (this.$el.clientHeight + this.$el.scrollTop >= this.$el.scrollHeight) {
      this.loadInfors(true)
    }
  }

  async loadInfors(loadMore = false){
    if (this.loading) {
      return
    }

    if (!loadMore) {
      this.page = 0
      this.infors = []
      this.isEnd = false
    } else {
      if (this.isEnd) {
        return
      }
      this.page += 1
    }
    try {
      this.loading= true

      const more = await api.infor.index(this.page)
      this.infors = [...this.infors, ...more]

      if (more.length < 20) {
        this.isEnd = true
      }
    } finally {
      this.loading= false
    }
  }

  async readAll(){
    await api.infor.readAll()
    this.loadInfors(false)
  }

  toInfo(info: Information) {
    this.$router.push({
      name: ROUTER_NAME.INFOR_DETAIL,
      params: {
        inforId: info.id.toString()
      }
    })
  }
}
